import {Component, Input} from '@angular/core';
import {FileViewerManagerService} from '../../../../Services/Shared/file-viewer-manager.service';

@Component({
  selector: 'app-message-item',
  templateUrl: './message-item.component.html',
  styleUrls: ['./message-item.component.scss'],
  standalone: false
})
export class MessageItemComponent {
  @Input() avatar: string = '';
  @Input() user: string = '';
  @Input() date: string = '';
  @Input() message: string = '';
  @Input() file: string = '';
  @Input() ext: string = '';
  @Input() isMine: boolean = false;

  constructor(
    public fileViewerManager: FileViewerManagerService,
  ) {
  }

}
